<template>
  <div class="app-container">
    <van-dropdown-menu>
      <van-dropdown-item v-model="params.pickerTime" @change="handleTimeChange" :options="params.pickerTimeOptions" />
      <van-dropdown-item v-if="params.pickerOrderOptions.length>0" v-model="params.pickerOrder"
        @change="handleOrderChange" :options="params.pickerOrderOptions" />
    </van-dropdown-menu>
    <component :is="currentList" :orders="orders"></component>
  </div>
</template>

<script>
import { DropdownMenu, DropdownItem } from 'vant';
import Available from './components/Available'
import Unavailable from './components/Unavailable'
import { selectWxPaidrecordList } from '@/api/park'
import { deepClone, parseTime } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'Order-List',
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    Available,
    Unavailable
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'token'])
  },
  created () {
    this.componentsValve()
  },
  data () {
    return {
      getInfo_Loading: null,
      currentList: 'Unavailable',
      listQuery: {
        //过滤参数
        page: 1,
        limit: 10,
      },
      params: {
        pickerTime: 1,
        pickerOrder: 'positive',
        parkId: null,
        outTradeNo: null,
        pickerTimeOptions: [
          { text: '今天', value: 1 },
          { text: '最近一周', value: 7 },
          { text: '最近一个月', value: 30 },
          { text: '最近三个月', value: 90 }
        ],
        pickerOrderOptions: [
        ],
        startDate: [
          parseTime(
            new Date(
              new Date(new Date().toLocaleDateString()).getTime() -
              24 * 60 * 60 * 1000
            )
          ),
          parseTime(new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 - 1
          ))
        ],
      },
      orders: []
    }
  },
  methods: {
    // 时间选项改变
    handleTimeChange (val) {
      this.params.startDate[0] = parseTime(new Date(new Date(new Date().toLocaleDateString()).getTime() - val * 24 * 60 * 60 * 1000))
      this.componentsValve()
    },
    // 排序选项改变
    handleOrderChange (val) {
      console.log(val)
    },
    componentsValve () {
      let _this = this
      let params = {
        openid: _this.wx_userInfo ? _this.wx_userInfo.openid : '',
        startTime: _this.params.startDate[0],
        endTime: _this.params.startDate[1],
        startPage: _this.listQuery.page,
        pageSize: _this.listQuery.limit,
        parkId: _this.params.parkId,
        outTradeNo: _this.params.outTradeNo,
        isInvoice: -1,
      }
      _this.getInfo_Loading = _this.$toast.loading('加载中...')
      selectWxPaidrecordList(params)
        .then(response => {
          let data = response.body
          _this.params.pickerOrderOptions = []
          data.forEach(element => {
            let obj = {
              value: element.parkId ? element.parkId : 0,
              text: element.parkName ? element.parkName : "",
              type: element.type ? element.type : 0,
            }
            _this.params.pickerOrderOptions.push(obj)
          });
          _this.getInfo_Loading.clear()
          if (data.length > 0) {
            _this.params.pickerOrder = _this.params.pickerOrderOptions[0].value
            _this.orders = deepClone(data)
            _this.currentList = 'Available'
          } else {
            _this.currentList = 'Unavailable'
          }
        })
        .catch(error => {
          _this.getInfo_Loading.clear()
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    }
  }
}
</script>